import React from 'react';
import { Star, Quote } from 'lucide-react';
const REVIEWS = [{
  name: 'Michael R.',
  location: 'Gilbert, AZ',
  text: 'They completely transformed the front of our house. The palm trees look amazing at night and the whole install was clean and professional. Couldn’t be happier.'
}, {
  name: 'Sandra K.',
  location: 'Chandler, AZ',
  text: 'From the design walkthrough to the finished install, everything was top notch. Our neighbors keep asking who did our lighting. Highly recommend.'
}, {
  name: 'David T.',
  location: 'Queen Creek, AZ',
  text: 'Replaced our old failing lights with new LEDs. Huge difference in brightness and the electric bill actually went down. Great local company.'
}];
export function Reviews() {
  return <section id="reviews" className="w-full border-y border-border bg-card py-20 lg:py-28" data-id="element-134" data-mp="3f0mgk09rh5f2">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-135" data-mp="3jzgykzzwmpy4">
        <div className="mx-auto max-w-2xl text-center" data-id="element-136" data-mp="3jzpb2qs47t8s">
          <span className="font-display text-lg tracking-wide text-accent" data-id="element-137" data-mp="2rd70kcdaccrv">Reviews</span>
          <h2 className="mt-2 font-display text-4xl leading-tight text-foreground sm:text-5xl" data-id="element-138" data-mp="2mduevuy5hbqv">
            What Our Neighbors Say
          </h2>
          <div className="mt-4 flex items-center justify-center gap-2" data-id="element-139" data-mp="2heztcl8st932">
            <div className="flex" aria-hidden="true" data-id="element-140" data-mp="2ddnyo1b2hxo0">
              {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="h-5 w-5 fill-accent text-accent" data-id="element-141" data-mp="3a1u2im060m18" data-mpi={i} />)}
            </div>
            <span className="text-muted-foreground" data-id="element-142" data-mp="354lrr6hcjka0">5.0 rating on Google</span>
          </div>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-143" data-mp="30biy6yckkatt">
          {REVIEWS.map(r => <blockquote key={r.name} className="rounded-xl border border-border bg-background p-7" data-id="element-144" data-mp="2wb8q9g57vacb">
              <Quote className="h-8 w-8 text-accent" aria-hidden="true" data-id="element-145" data-mp="3sv7s0bl4009g" />
              <p className="mt-4 leading-relaxed text-foreground" data-id="element-146" data-mp="3o1vccqyer3su">“{r.text}”</p>
              <footer className="mt-6" data-id="element-147" data-mp="1m4unhhkw5r0f">
                <p className="font-display text-lg text-foreground" data-id="element-148" data-mp="1m5w9gh3g3xwx">{r.name}</p>
                <p className="text-sm text-muted-foreground" data-id="element-149" data-mp="1r3fq1nnm8ms1">{r.location}</p>
              </footer>
            </blockquote>)}
        </div>
      </div>
    </section>;
}